// Tiny matchMedia hook. Returns a boolean that updates when the query
// flips. Used by InventoryGrid to render EITHER the desktop table or the
// mobile card list, not both (was rendering 47 × 2 = 94 SKU elements at
// all viewports, doubling DOM weight for nothing).

import { useEffect, useState } from 'react';

export function useMediaQuery(query) {
  const [matches, setMatches] = useState(() => {
    if (typeof window === 'undefined' || !window.matchMedia) return false;
    return window.matchMedia(query).matches;
  });

  useEffect(() => {
    if (typeof window === 'undefined' || !window.matchMedia) return;
    const mql = window.matchMedia(query);
    const onChange = (e) => setMatches(e.matches);
    // Modern browsers expose addEventListener; older Safari uses addListener.
    if (mql.addEventListener) mql.addEventListener('change', onChange);
    else mql.addListener(onChange);
    setMatches(mql.matches);     // resync in case it changed between init + effect
    return () => {
      if (mql.removeEventListener) mql.removeEventListener('change', onChange);
      else mql.removeListener(onChange);
    };
  }, [query]);

  return matches;
}

// Sugar: returns true on mobile viewports (≤768px). Matches the breakpoint
// used in inventory-grid.css (.inv-mobile-list / .inv-grid-wrap toggle).
export function useIsMobile() {
  return useMediaQuery('(max-width: 768px)');
}
